import { useEffect, useRef } from 'react';

/** Lightweight canvas confetti in KES blues with gold accents. Respects prefers-reduced-motion. */
export function Confetti({ active = true, density = 180 }: { active?: boolean; density?: number }) {
  const ref = useRef<HTMLCanvasElement>(null);
  useEffect(() => {
    const canvas = ref.current;
    if (!canvas || !active) return;
    if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) return;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;
    const colors = ['#2F80C8', '#5AA8DA', '#FFFFFF', '#F5B21B', '#FFD45C', '#1F5F8F'];
    let w = 0, h = 0;
    const resize = () => { w = canvas.width = canvas.clientWidth * devicePixelRatio; h = canvas.height = canvas.clientHeight * devicePixelRatio; };
    resize();
    window.addEventListener('resize', resize);
    const parts = Array.from({ length: density }, () => ({
      x: Math.random() * w, y: Math.random() * -h, s: (6 + Math.random() * 10) * devicePixelRatio,
      vy: (1.5 + Math.random() * 3) * devicePixelRatio, vx: (Math.random() - 0.5) * 1.5 * devicePixelRatio,
      a: Math.random() * Math.PI, va: (Math.random() - 0.5) * 0.2, c: colors[Math.floor(Math.random() * colors.length)]!,
    }));
    let raf = 0;
    const tick = () => {
      ctx.clearRect(0, 0, w, h);
      for (const p of parts) {
        p.y += p.vy; p.x += p.vx + Math.sin(p.a) * 0.6; p.a += p.va;
        if (p.y > h + 20) { p.y = -20; p.x = Math.random() * w; }
        ctx.save(); ctx.translate(p.x, p.y); ctx.rotate(p.a); ctx.fillStyle = p.c;
        ctx.fillRect(-p.s / 2, -p.s / 4, p.s, p.s / 2); ctx.restore();
      }
      raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => { cancelAnimationFrame(raf); window.removeEventListener('resize', resize); };
  }, [active, density]);
  return <canvas ref={ref} aria-hidden="true" style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', pointerEvents: 'none' }} />;
}
